import React from 'react';
import { AlertTriangle } from 'lucide-react';
import MaturityBar from './MaturityBar';
import VendorCoverageBadge from './VendorCoverageBadge';

const CapabilityCard = ({
  capability,
  assessment,
  vendorCoverage,
  pillarColor,
  assessmentMode = false,
  onUpdateAssessment
}) => {
  const isAb869Critical = capability.ab869_critical || capability.is_critical;
  const currentMaturity = assessment?.maturity_level || null;
  const coverageStatus = vendorCoverage?.coverage_status || null;

  const handleMaturitySelect = (maturityLevel) => {
    if (!assessmentMode || !onUpdateAssessment) return;
    onUpdateAssessment(capability.zt_capability_id, { maturity_level: maturityLevel });
  };

  return (
    <div
      className={`capability-card ${isAb869Critical ? 'capability-card--critical' : ''} ${vendorCoverage ? 'capability-card--has-vendor' : ''}`}
      style={vendorCoverage ? { borderLeftColor: pillarColor } : undefined}
    >
      {/* Header */}
      <div className="capability-card-header">
        <div className="capability-card-name-row">
          <span className="capability-card-name">{capability.capability_name}</span>
          <div className="capability-card-badges">
            {isAb869Critical && (
              <span className="capability-ab869-badge" title="AB 869 Critical">
                <AlertTriangle size={10} />
                AB 869
              </span>
            )}
            {vendorCoverage && (
              <VendorCoverageBadge coverage={coverageStatus} />
            )}
          </div>
        </div>
      </div>

      {/* Description */}
      {capability.capability_description && (
        <p className="capability-card-desc">{capability.capability_description}</p>
      )}

      {/* Maturity Bar */}
      <div className="capability-card-maturity">
        <MaturityBar
          currentMaturity={currentMaturity}
          onSelect={handleMaturitySelect}
          interactive={assessmentMode}
          compact
        />
      </div>

      {/* Assessment details when in assessment mode */}
      {assessmentMode && assessment && (
        <div className="capability-card-assessment">
          {assessment.implementation_status && (
            <span className={`status-chip status-chip--${assessment.implementation_status.toLowerCase()}`}>
              {assessment.implementation_status.replace('_', ' ')}
            </span>
          )}
          {assessment.priority && (
            <span className={`priority-chip priority-chip--${assessment.priority.toLowerCase()}`}>
              {assessment.priority}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default CapabilityCard;
